
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
import ListTable from './ListTable'
import EntryDialog from './EntryDialog'
const components = {
  layout,
  ListTable,
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `Finance/CashAccountSummarize/loadingState`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  reload: `Finance/CashAccountSummarize/fetchData`,
})

methods.addNewRecord = function() {
  this.$refs.EntryDialog.show()
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Laporan Keuangan`)
  this.$store.commit(`set_breadcrumb`, [ `Rekening Akun` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<style scoped>
</style>

<template>
  <layout>
    <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Rekening Balance

          <div class="pull-right">
            <ButtonL icon="repeat" color="default" @click="reload" />
            <ButtonL text="Kredit / Debit" color="primary" @click="addNewRecord" />
          </div>
        </template>
        <template #content>
          <ListTable />
        </template>
      </BlockTable>
    </Row>

    <EntryDialog ref="EntryDialog"></EntryDialog>
  </layout>
</template>